import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'

const { id, dataset } = document.body;
const { flashNotice, flashError } = dataset;

// check for flash
const notyf = new Notyf({
  duration: 5000,
  position: {
    x: 'right',
    y: 'top',
  },
  dismissible: true,
});

if (id === 'home-index') {
  import('../js/views/index.js');
} else if ( id === 'devise-sessions-new') {
  import('../js/views/devise/sessions/new');
} else if ( id === 'devise-passwords-new') {
  import('../js/views/devise/passwords/new');
} else if ( id === 'devise-passwords-edit') {
  import('../js/views/devise/passwords/edit');
}

// Setup header
const profileMenuLink = document.getElementById('profile-menu-link');
const languageMenuLink = document.getElementById('language-menu-link');
const countryMenuLink = document.getElementById('country-menu-link');
const profileDropdown = document.getElementById('profile-dropdown');
const languageDropdown = document.getElementById('language-dropdown');
const countryDropdown = document.getElementById('country-dropdown');

if (profileMenuLink && profileDropdown) {
  profileMenuLink.addEventListener('click', (e) => {
    profileDropdown.classList.toggle('show');
  });
}

if (languageMenuLink && languageDropdown) {
  languageMenuLink.addEventListener('click', (e) => {
    languageDropdown.classList.toggle('show');
  });
}

if (countryMenuLink && countryDropdown) {
  countryMenuLink.addEventListener('click', (e) => {
    countryDropdown.classList.toggle('show');
  });
}

// This will close the dropdown menus if a click occurs outside of them
if (languageMenuLink && profileMenuLink && countryMenuLink) {
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('profile')) {
      profileDropdown.classList.remove('show');
    }
    if (!e.target.classList.contains('language')) {
      languageDropdown.classList.remove('show');
    }
    if (!e.target.classList.contains('country')) {
      countryDropdown.classList.remove('show');
    }
  });
} else if (languageMenuLink) {
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('language')) {
      languageDropdown.classList.remove('show');
    }
  });
} else if (profileMenuLink) {
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('profile')) {
      profileDropdown.classList.remove('show');
    }
  });
} else if (countryMenuLink) {
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('country')) {
      countryDropdown.classList.remove('show');
    }
  });
}

const userMenuOverlay = document.getElementById("userMenuOverlay");
const menuOverlay = document.getElementById("menuOverlay");
const closeUserMenuButton = document.getElementById("close-user-menu");
const closeMenuButton = document.getElementById("close-menu");
const userMenuIcon = document.getElementById("mobile-user-menu");
const menuIcon = document.getElementById("mobile-menu");

// Show the full-screen overlay when the userMenuIcon is clicked
if (userMenuIcon) {
  userMenuIcon.addEventListener("click", function () {
    userMenuOverlay.style.display = "block";
  });
}

// Show the full-screen overlay when the menuIcon is clicked
if (menuIcon) {
  menuIcon.addEventListener("click", function () {
    menuOverlay.style.display = "block";
  });
}

function closeMenuHandler() {
  userMenuOverlay.style.display = "none";
  menuOverlay.style.display = "none";
}

// Hide the full-screen overlay when the close button is clicked
if (closeUserMenuButton) {
  closeUserMenuButton.addEventListener("click", closeMenuHandler);
}

if (closeMenuButton) {
  closeMenuButton.addEventListener("click", closeMenuHandler);
}

// Show messages from Rails flash
function showFlashMessages() {
  const body = document.body
  const notice = body.dataset.flashNotice
  const alert = body.dataset.flashAlert

  if (notice) {
    notyf.success(notice)
  }
  if (alert) {
    notyf.error(alert)
  }
}

// Use the below to show flash messages
document.addEventListener('DOMContentLoaded', () => {
  showFlashMessages()
})